export enum EditorType {
	HTML = 'HTML',
	INDESIGN = 'INDESIGN',
}

export enum EditableType {
	text = 'text',
	image = 'image',
	video = 'video',
	animation = 'animation',
	link = 'link',
}

export enum LinkType {
	url = 'url',
	gotoPage = 'gotoPage',
}

export const colorMarkClassName = 'rte-font-color';
export const linkClassName = 'rte-underline';
export const editedElementClassName = 'edited';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/constants.ts